import React from "react";
import MasterLayout from "../otherImages/MasterLayout";
import InventoryList from "../components/InventoryList";
import DefaultTopBar from "../components/DefaultTopBar";

const ManagePackages = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout> 

        <DefaultTopBar
            title="Manage Inventories"
        />

        {/* TableDataLayer */}
        <InventoryList />

      </MasterLayout>

    </>
  );
};

export default ManagePackages; 
